// Pickup Form Component
export const FORM_SEARCH_FORM_ADDRESS_PLACEHOLDER = "Enter Your Address";

export default {
  FORM_SEARCH_FORM_ADDRESS_PLACEHOLDER,
};
